import { useQuery } from 'react-query';
import axiosInstance from '../../config/axiosInstance';
import { urls } from '../../config/urls';

export const useCounts = () => {
  return useQuery('count', () =>
    axiosInstance.get(urls.dashboard.statistics).then((res) => res.data)
  );
};

export const useOrdersChart = (from: string, to: string) => {
  return useQuery(['ordersChart', from, to], () =>
    axiosInstance
      .get(urls.dashboard.ordersChart, {
        params: {
          from,
          to,
        },
      })
      .then((res) => res.data)
  );
};

export const useLatestOrders = () => {
  return useQuery(['latestOrders'], () =>
    axiosInstance.get(urls.dashboard.latestOrders).then((res) => res.data)
  );
};
